import _ from "lodash";
import { Grid, Header } from "semantic-ui-react";
import styled from "styled-components";

const GridColumnStyled = styled(Grid.Column)`
  ${(props) => (props.verticalcenter ? "display: flex !important;" : null)}

  & .ui.header {
    margin-bottom: 1rem;
    ${(props) =>
      props.verticalcenter ? "margin-bottom: 0; align-self: center;" : null}
  }
`;

const TitleHeaderLarge = ({
  header,
  detail,
  children,
  attached,
  childStyle,
  loading,
  verticalCenter,
}) => {
  // don't show subheader when loading
  let subheading = null;
  if (!loading && detail) {
    subheading = _.isPlainObject(detail)
      ? detail
      : _.castArray(detail).map((d) => <p key={d}>{d}</p>);
  }

  return (
    <Grid>
      <GridColumnStyled
        mobile={16}
        tablet={11}
        computer={11}
        verticalcenter={verticalCenter}
      >
        <Header as="h1">{header}</Header>
        {subheading && <div style={{ marginBottom: "1rem" }}>{subheading}</div>}
      </GridColumnStyled>
      {!loading && (
        <Grid.Column mobile={16} tablet={5} computer={5} style={childStyle}>
          {children}
        </Grid.Column>
      )}
    </Grid>
  );
};

export default TitleHeaderLarge;
